<script setup lang="ts">
const config = useRuntimeConfig()

const posieLink = config.public.posieUrl + '/jewelry';
</script>

<template>
  <a :href="posieLink" class="posie-banner" target="_blank">
    <div class="posie-banner__top">
      <svg
        class="posie-banner__top-left"
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.5934 0H16V16H0.000203852V10.6051C0.000254785 9.0138 0.632418 7.48773 1.75762 6.36255L6.36297 1.7573C7.48533 0.634966 9.00653 0.00320127 10.5934 0Z"
          fill="#FAFAFA"
        />
        <path
          d="M15.9954 1H10.5945C9.27243 1.00292 8.00514 1.52936 7.07007 2.46441L2.46472 7.06967C1.52705 8.00731 1.00025 9.27904 1.0002 10.6051L1.00003 16H0L0.000203852 10.6051C0.000254785 9.0138 0.632418 7.48773 1.75762 6.36255L6.36297 1.7573C7.48533 0.634966 9.00653 0.00320127 10.5934 0H15.9954V1Z"
          fill="#E3E4EA"
        />
      </svg>
      <div class="posie-banner__top-middle"></div>
      <svg
        class="posie-banner__top-right"
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.40656 0H0V16H15.9998V10.6051C15.9997 9.0138 15.3676 7.48773 14.2424 6.36255L9.63703 1.7573C8.51467 0.634966 6.99347 0.00320127 5.40656 0Z"
          fill="#FAFAFA"
        />
        <path
          d="M0.00461578 1H5.40551C6.72757 1.00292 7.99486 1.52936 8.92993 2.46441L12.8634 6.39775L13.5353 7.06967C14.4729 8.00731 14.9998 9.27904 14.9998 10.6051L15 16H16L15.9998 10.6051C15.9997 9.0138 15.3676 7.48773 14.2424 6.36255L13.5353 5.65547L9.63703 1.7573C8.51467 0.634966 6.99347 0.00320127 5.40656 0H0.00461578V1Z"
          fill="#E3E4EA"
        />
      </svg>
    </div>
    <div class="posie-banner__middle">
      <div class="posie-banner__text">Посмотреть каталог украшений POSIÉ</div>
      <svg
        class="posie-banner__icon"
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <rect width="20" height="20" rx="10" fill="#222736" />
        <path d="M7 13.5L13 7.5M13 7.5V13.5M13 7.5H7" stroke="white" />
      </svg>
    </div>
    <div class="posie-banner__bottom">
      <svg
        class="posie-banner__bottom-left"
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.5934 16H16V0H0.000203852V5.39494C0.000254785 6.9862 0.632418 8.51227 1.75762 9.63745L6.36297 14.2427C7.48533 15.365 9.00653 15.9968 10.5934 16Z"
          fill="#FAFAFA"
        />
        <path
          d="M15.9954 15H10.5945C9.27243 14.9971 8.00514 14.4706 7.07007 13.5356L2.46472 8.93033C1.52705 7.99269 1.00025 6.72096 1.0002 5.39491L1.00003 0H0L0.000203852 5.39494C0.000254785 6.9862 0.632418 8.51227 1.75762 9.63745L6.36297 14.2427C7.48533 15.365 9.00653 15.9968 10.5934 16H15.9954V15Z"
          fill="#E3E4EA"
        />
      </svg>
      <div class="posie-banner__bottom-middle"></div>
      <svg
        class="posie-banner__bottom-right"
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M5.40656 16H0V0H15.9998V5.39494C15.9997 6.9862 15.3676 8.51227 14.2424 9.63745L9.63703 14.2427C8.51467 15.365 6.99347 15.9968 5.40656 16Z"
          fill="#FAFAFA"
        />
        <path
          d="M0.00461578 15H5.40551C6.72757 14.9971 7.99486 14.4706 8.92993 13.5356L13.5353 8.93033C14.4729 7.99269 14.9998 6.72096 14.9998 5.39491L15 0H16L15.9998 5.39494C15.9997 6.9862 15.3676 8.51227 14.2424 9.63745L9.63703 14.2427C8.51467 15.365 6.99347 15.9968 5.40656 16H0.00461578V15Z"
          fill="#E3E4EA"
        />
      </svg>
    </div>
  </a>
</template>

<style scoped lang="scss">
.posie-banner {
}

.posie-banner__top,
.posie-banner__bottom {
  display: flex;
  width: 100%;
}
.posie-banner__top-left,
.posie-banner__top-right,
.posie-banner__bottom-left,
.posie-banner__bottom-right {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}
.posie-banner__top-middle,
.posie-banner__bottom-middle {
  background: var(--Surface-surface-100, #FAFAFA);
  flex-grow: 1;
  width: 100%;
}
.posie-banner__top-middle {
  border-top: 1px solid var(--Border-border-300, #E3E4EA);
}
.posie-banner__bottom-middle {
  border-bottom: 1px solid var(--Border-border-300, #E3E4EA);
}

.posie-banner__middle {
  display: flex;
  align-items: center;
  gap: var(--Sizes-Gap-gap-150, 12px);
  padding-inline: var(--Sizes-Padding-padding-250, 16px);
  border: {
    width: 0 1px 0 1px;
    style: solid;
    color: var(--Border-border-300, #E3E4EA);
  }
}

.posie-banner__text {
  color: var(--Text-text-primary, #222736);

  /* 1280+/Paragraph M */
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 133.333% */
  letter-spacing: 0.15px;

  flex-grow: 1;
}

.posie-banner__icon {
  flex-shrink: 0;
}
</style>
